import { render, staticRenderFns } from "./ProgramTabRegistrationStatuses.vue?vue&type=template&id=459956e1&"
import script from "./ProgramTabRegistrationStatuses.vue?vue&type=script&lang=js&"
export * from "./ProgramTabRegistrationStatuses.vue?vue&type=script&lang=js&"
import style0 from "./ProgramTabRegistrationStatuses.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports